/** Canonical hex values — single source of truth for TJ brand colors */
export const palette = {
  almostBlack: "#2C2C2C",
  red: "#C81E24",
  natural: "#A5684D",
  earlGrey: "#727272",
  notQuiteWhite: "#F8F8F2",
  selectedGrey: "#E8E8E6",
  boxLightGrey: "#F6F7F2",
  mellowYellow: "#F0DE9A",
  sapphire: "#27365C",
  boxBorder: "#DEDEDE",
  tabBorder: "#D9CEC1",
  inputField: "#A0A0A0",
  peacock: "#446866",
  dark: "#2E2E2E",
  dark2: "#1E1E1E",
  dark3: "#444444",
  dark4: "#555555",
  greyWhite: "#E0E0E0",
  white: "#FFFFFF",
  black: "#000000",
  auditInProgress: "#FEC84B",
  auditCompleted: "#D0E81E",
  auditCancelled: "#FFBCBC",
  auditScheduled: "#D8D8D8",
  auditUnderTjReview: "#9AF0E1",
  auditDraft: "#E8E0F0",
} as const;

/** Tailwind theme.extend.colors shape */
export const tailwindColors: Record<string, string> = {
  "TJ-Almost-Black": palette.almostBlack,
  "TJ-Red": palette.red,
  "TJ-Natural": palette.natural,
  "TJ-Earl-Grey": palette.earlGrey,
  "TJ-Not-Quite-White": palette.notQuiteWhite,
  "TJ-Selected-Grey": palette.selectedGrey,
  "TJ-Box-Light-Grey": palette.boxLightGrey,
  "TJ-Mellow-Yellow": palette.mellowYellow,
  "TJ-Sapphire": palette.sapphire,
  "TJ-Box-Border": palette.boxBorder,
  "TJ-Tab-Border": palette.tabBorder,
  "TJ-Input-Field": palette.inputField,
  "TJ-Peacock": palette.peacock,
  "TJ-Dark": palette.dark,
  "TJ-Dark2": palette.dark2,
  "TJ-Dark3": palette.dark3,
  "TJ-Dark4": palette.dark4,
  "TJ-white": palette.greyWhite,
  "TJ-Audit-In-Progress": palette.auditInProgress,
  "TJ-Audit-Completed": palette.auditCompleted,
  "TJ-Audit-Cancelled": palette.auditCancelled,
  "TJ-Audit-Scheduled": palette.auditScheduled,
  "TJ-Audit-Under-TJ-Review": palette.auditUnderTjReview,
  "TJ-Audit-Draft": palette.auditDraft,
};

export const getPrimaryTextColor = (darkMode: boolean): string =>
  darkMode ? palette.notQuiteWhite : palette.almostBlack;

export const getModalSurfaceColor = (darkMode: boolean): string =>
  darkMode ? palette.dark2 : palette.white;

export const getCloseIconColor = (darkMode: boolean): string =>
  darkMode ? palette.white : palette.black;
